import { useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Pagination.css"; // Import the CSS

export default function Pagination({ limit, currentPage, totalPages }) {
  const [inputPage, setInputPage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  totalPages = parseInt(totalPages);
  currentPage = parseInt(currentPage);

  // Helper to build a new query string while keeping all existing params
  const buildUrl = (newParams = {}) => {
    const params = new URLSearchParams(location.search);

    // Merge new params into existing ones
    Object.entries(newParams).forEach(([key, value]) => {
      params.set(key, value);
    });

    return `${location.pathname}?${params.toString()}`;
  };

  const handleInputSubmit = (e) => {
    e.preventDefault();
    const page = parseInt(inputPage);
    setInputPage("");
    if (!isNaN(page) && page >= 1 && page <= totalPages) {
      navigate(buildUrl({ limit, page }));
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 3;

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    if (startPage > 1) {
      pages.push(
        <Link
          to={buildUrl({ limit, page: 1 })}
          key={1}
          className={`page-link ${1 === currentPage ? "active" : ""}`}
        >
          1
        </Link>
      );
      if (startPage > 2) {
        pages.push(
          <span key="start-ellipsis" className="ellipsis">
            ...
          </span>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <Link
          to={buildUrl({ limit, page: i })}
          key={i}
          className={`page-link ${i === currentPage ? "active" : ""}`}
        >
          {i}
        </Link>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <span key="end-ellipsis" className="ellipsis">
            ...
          </span>
        );
      }
      pages.push(
        <Link
          to={buildUrl({ limit, page: totalPages })}
          key={totalPages}
          className={`page-link ${totalPages === currentPage ? "active" : ""}`}
        >
          {totalPages}
        </Link>
      );
    }

    return pages;
  };

  return totalPages > 1 ? (
    <div className="pagination-container">
      <div className="pagination-controls">
        {currentPage === 1 ? (
          <span className="nav-arrow disabled">
            <FaChevronLeft />
          </span>
        ) : (
          <Link
            to={buildUrl({ limit, page: currentPage - 1 })}
            className="nav-arrow"
          >
            <FaChevronLeft />
          </Link>
        )}

        <div className="page-numbers">{renderPageNumbers()}</div>

        {currentPage === totalPages ? (
          <span className="nav-arrow disabled">
            <FaChevronRight />
          </span>
        ) : (
          <Link
            to={buildUrl({ limit, page: currentPage + 1 })}
            className="nav-arrow"
          >
            <FaChevronRight />
          </Link>
        )}
      </div>

      <form onSubmit={handleInputSubmit} className="goto-form">
        <span className="goto-label">Go to page:</span>
        <input
          type="number"
          min="1"
          max={totalPages}
          value={inputPage}
          onChange={(e) => setInputPage(e.target.value)}
          className="goto-input"
          placeholder="#"
          required
          name="page"
        />
        <button type="submit" className="goto-button">
          Go
        </button>
      </form>
    </div>
  ) : null;
}
